import React from 'react';
import { TextInput, TextInputProps } from 'react-native';
import { INPUT_PLACEHOLDER_COLOR } from '../constants/colors';

/**
 * TextInput with consistent gray placeholder styling across web and native.
 */
const AppTextInput = React.forwardRef<TextInput, TextInputProps>(function AppTextInput(
  { placeholderTextColor, ...props },
  ref,
) {
  return (
    <TextInput
      ref={ref}
      placeholderTextColor={placeholderTextColor ?? INPUT_PLACEHOLDER_COLOR}
      {...props}
    />
  );
});

export default AppTextInput;
